/**
 * Per-tenant feature flag keys — mirror of the backend `FEATURE_KEYS` registry
 * (`@pagai/common`). Single source of truth on the client for gating routes
 * (`featureGuard`), sidebar items and the `*appHasFeature` directive.
 *
 * Keep in sync with the backend registry.
 */
export const FEATURE_KEYS = {
  PAYSLIPS: 'payslips',
  EXPENSE_REPORTS: 'expenseReports',
  LEAVE_REQUESTS: 'leaveRequests',
  DOCUMENTS: 'documents',
  BACHECA: 'bacheca',
} as const;

/** Union of the known feature flag keys. */
export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS];
